export const HOTEL_FAQ_ITEM_TEST_ID = 'HOTEL_FAQ_ITEM_TEST_ID';
export const HOTEL_FAQ_ITEM_BUTTON_TEST_ID = 'HOTEL_FAQ_ITEM_BUTTON_TEST_ID';
export const HOTEL_FAQ_ITEM_TITLE_TEST_ID = 'HOTEL_FAQ_ITEM_TITLE_TEST_ID';
export const HOTEL_FAQ_ITEM_DESCRIPTION_TEST_ID =
  'HOTEL_FAQ_ITEM_DESCRIPTION_TEST_ID';
